import manifest from "./posthogReplayPresentationManifest.json"

const classes = new Set(manifest.classes)
const attributes = new Map(Object.entries(manifest.attributes).map(([name, values]) => [name, new Set(values)]))

const registries = new WeakMap()

// The server resolves exact public build URLs from the finite source manifest.
// Do not infer ownership from a filename extension or a digest-shaped suffix.
export function publicReplayAsset(value) {
  if (typeof value !== "string" || !value) return null
  try {
    const url = new URL(value, window.location.origin)
    if (url.origin !== window.location.origin || url.search || url.hash || url.username || url.password) return null
    const metadata = document.querySelector('meta[name="posthog-public-replay-assets"]')
    if (!metadata) return null
    let registry = registries.get(metadata)
    if (!registry) {
      if (metadata.content.length > 256 * 1024) return null
      const paths = JSON.parse(metadata.content)
      if (!Array.isArray(paths) || paths.length > 2000) return null
      registry = new Set(paths.filter(path => typeof path === "string" && path.startsWith("/") && !path.startsWith("//")))
      registries.set(metadata, registry)
    }
    return registry.has(url.pathname) ? url.href : null
  } catch { /* Invalid URLs or malformed public metadata remain private. */ }
  return null
}

export function maskReplayAttribute(name, value, element) {
  const lower = name.toLowerCase()
  if (lower === "class") return String(value).split(/\s+/).filter(token => classes.has(token)).join(" ")
  if ((lower === "src" && element?.tagName?.toLowerCase() === "img") ||
      (lower === "href" && ["link", "image"].includes(element?.tagName?.toLowerCase()))) return publicReplayAsset(value) || ""
  if (attributes.get(lower)?.has(value)) return value
  if (lower === "rel" && ["stylesheet", "preload", "icon", "apple-touch-icon"].includes(value)) return value
  if (lower === "media" && ["all", "screen"].includes(value)) return value
  if (lower === "as" && ["style", "font", "image"].includes(value)) return value
  if (lower === "crossorigin" && ["", "anonymous"].includes(value)) return value
  return ""
}
